import { connect } from 'react-redux';
import PlayerControls from '../components/playerControls/playerControls';
import { toggleControls } from '../Actions';
const mapStateToProps = state => ({
    isMobile: state.layout.isMobile,
    showControls: state.layout.showControls,
    hideElements: state.scene.sceneSettings.hideElements,
    miniUi: state.layout.miniUi,
});
const mapDispatchToProps = dispatch => ({
    toggleControls: showControls => {
        dispatch(toggleControls(!showControls));
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(PlayerControls);
